// extracted by mini-css-extract-plugin
export var Heading = "footer-module--Heading--60597";
export var copyright = "footer-module--copyright--e5100";
export var menuGroup = "footer-module--menuGroup--06fdf";
export var minimal = "footer-module--minimal--5909a";
export var nav = "footer-module--nav--55142";
export var siteFooter = "footer-module--siteFooter--7c965";
export var socials = "footer-module--socials--d38f9";
export var subMenu = "footer-module--subMenu--464c1";